export class NotesHttp {
    /**
     * Get notes
     * @returns {Promise<void>}
     */
    static async getAllNotes() {
        try {
            return await window.axios.get(`notes`).then(result => result.data);
        } catch (e) {
            return await Promise.reject(e);
        }
    }

    /**
     * Creates a note
     * @param note
     * @returns {Promise<AxiosResponse<any>>}
     */
    static async createNote(note) {
        try {
            return await window.axios.post(`notes`, note).then(result => result.data);
        } catch (e) {
            return await Promise.reject(e);
        }
    }

    /**
     * Delete note
     * @param id
     * @returns {Promise<void>}
     */
    static async deleteNotes(id) {
        try {
            return await window.axios.delete(`notes/${id}`).then(result => result.data);
        } catch (e) {
            return await Promise.reject(e);
        }
    }
}
